import i18next from "i18next";
import { initReactI18next, useTranslation as useTranslationI18next, Trans, } from "react-i18next";
import { useEffect, createElement } from "react";
import LanguageDetector from "i18next-browser-languagedetector";
export const createTranslations = (config = { resources: {} }, initialize = true, onInitializeCallback) => {
    const i18n = i18next.createInstance({
        fallbackLng: "en",
        ...config,
        react: {
            transKeepBasicHtmlNodesFor: [
                "br",
                "strong",
                "i",
                "p",
                "b",
                "a",
                "span",
                "em",
                "ul",
                "ol",
                "li",
            ],
            ...(config.react ?? {}),
        },
    });
    i18n.use(LanguageDetector).init({
        detection: { order: ["cookie"], lookupCookie: "MDC.USER.LANGUAGE" },
    });
    i18n.use(initReactI18next);
    // choosing not to initialize upfront allows for dynamic resource management
    // https://www.i18next.com/how-to/add-or-load-translations#lazy-load-in-memory-translations
    if (initialize) {
        i18n.init(onInitializeCallback);
    }
    const useTranslation = (language) => {
        const { t, ...rest } = useTranslationI18next("", { i18n });
        useEffect(() => {
            if (language && i18n.language !== language) {
                i18n.changeLanguage(language);
            }
        }, [language]);
        return {
            // this wrapper makes the translation keys typesafe
            translate: (key) => t(key, {
                returnObjects: true,
            }),
            ...rest,
        };
    };
    return {
        i18n,
        useTranslation,
        TranslateHTML: ({ keyName, valueMapper = (x) => x, ...props }) => {
            const { translate } = useTranslation();
            // Making this file *.tsx caused problems with the complex types
            return createElement(Trans, {
                children: valueMapper(translate(keyName)),
                i18n,
                ...props,
            });
        },
    };
};
//# sourceMappingURL=create-translations.js.map